<div class="base-container">
  <div class="top">
    <div class="left">
      <div (click)="back()" class="back">
        <i class="fa fa-chevron-left"></i>
        Zurück
      </div>
      <div class="header">
        <div class="title">
          {{folder?.name}}
          <i (click)="bookmarksModal.open()" class="fa fa-pencil"></i>
        </div>
      </div>
    </div>
    <div class="nav">
      <button (click)="requestProject()" class="contact">Projektanfrage starten</button>
    </div>
  </div>
  <bd-hr></bd-hr>
  <div  class="products">
    <bdcp-product-result *ngFor="let product of folder?.favoriteProducts"
      class="product" (deleteProductFromFolder)="deleteProductFromFolder(product.manufacturerSKU)" [product]="product"
      [isBrotherProduct]="true" [bookmarkMode]="true"></bdcp-product-result>
    <div *ngFor="let pseudoProduct of pseudoProducts" bdFxFlex="1 1 calc(33.33333% - 12px * 2 / 3)" class="product"></div>
  </div>
</div>

<bd-modal #bookmarksModal [closable]="true" title="Merkliste umbenennen">
  <div class="name">
    Merklistenname
  </div>
  <div class="input-group">
    <input [(ngModel)]="newFolderName" type="text">
    <button (click)="updateFolder()">Umbenennen</button>
  </div>
</bd-modal>
